export default (text) => text?.replace(/<[\/]{0,1}(p)[^><]*>/g, "");
//# sourceMappingURL=removePTag.js.map